import { DevPushStateData } from '@sb/feathers-types';

import { getService } from '../utils';

/**
 * Fetch the current dev-push state from feathers-bot.
 *
 * Returns `{ source: null }` when the CB is not in dev-push mode OR when the
 * response cannot be validated against the schema. The latter case covers the
 * version-skew window where a new remote-control bundle is loaded in the
 * browser but the deployed feathers-bot is still on a pre-schema version
 * (response shape `{ services: [...] }` with no `source` field). Treating
 * malformed responses as "not in dev-push mode" makes the banner safely hide
 * rather than fall through to the default branch and render undefined fields.
 */
export async function getDevPushState(): Promise<DevPushStateData> {
  const service = getService('devPushState')();
  const result = await service.find({ query: {} });

  const raw = Array.isArray(result) ? result[0] : result;
  const parsed = DevPushStateData.safeParse(raw);

  if (!parsed.success) {
    return { source: null };
  }

  return parsed.data;
}
